$(window).scroll(function () {

   
   var scroll = $(window).scrollTop();
   if (scroll < 100) {
   $('.fixed-top').css({
   "background": "transparent",
   "box-shadow": "none"
   });
   } else {
   $('.fixed-top').css({
   "background": "#1e1e1e",
   "box-shadow": "9px 8px 15px -1px rgb(0 0 0 / 10%)"
   
   });
   }
   });
   
   
   var owl = $('.what_slider');
   owl.owlCarousel({
   items:3,
   loop:true,
   margin:8,
   navText: [
   "<img src='image/arrow-left.png'>",
   "<img src='image/arrow-right.png'>",
   ],
   autoplay:true,
   autoplayTimeout:5000,
   autoplayHoverPause:true,
   responsive:{
   0:{
   items:1
   },
   600:{
   items:2
   },
   1000:{
   items:3
   }
   }
   });
   $('.play').on('click',function(){
   owl.trigger('play.owl.autoplay',[5000])
   })
   $('.stop').on('click',function(){
   owl.trigger('stop.owl.autoplay')
   })


     
   const menu = document.querySelector(".menu");
const times = document.querySelector(".times");
const small = document.querySelector(".small");
const large = document.querySelector(".large");
const overlay = document.querySelector(".overlay");

menu.addEventListener("click", function () {
  small.classList.add("show");
  overlay.classList.add("show");
});
times.addEventListener("click", function () {
  small.classList.remove("show");
  overlay.classList.remove("show");
});

overlay.addEventListener("click", () => {
  small.classList.remove("show");
  overlay.classList.remove("show");
});


const linkSms = document.querySelectorAll(".link-sm");
linkSms.forEach((linkSm) => {
  linkSm.onclick = function () {
    const innerMenu = linkSm.children[2];
    console.log(innerMenu);
    if (innerMenu.style.maxHeight) {
      innerMenu.style.maxHeight = null;
    } else {
      innerMenu.style.maxHeight = innerMenu.scrollHeight + "px";
    }
  };
});


$('.search-toggle').addClass('closed');

$('.search-toggle .search-icon').click(function(e) {
  if ($('.search-toggle').hasClass('closed')) {
    $('.search-toggle').removeClass('closed').addClass('opened');
    $('.search-toggle, .search-container').addClass('opened');
    $('#search-terms').focus();
  } else {
    $('.search-toggle').removeClass('opened').addClass('closed');
    $('.search-toggle, .search-container').removeClass('opened');
  }
});
   


var QtyInput = (function () {
	var $qtyInputs = $(".qty-input");

	if (!$qtyInputs.length) {
		return;
	}

	var $inputs = $qtyInputs.find(".product-qty");
	var $countBtn = $qtyInputs.find(".qty-count");
	var qtyMin = parseInt($inputs.attr("min"));
	var qtyMax = parseInt($inputs.attr("max"));

	$inputs.change(function () {
		var $this = $(this);
		var $minusBtn = $this.siblings(".qty-count--minus");
		var $addBtn = $this.siblings(".qty-count--add");
		var qty = parseInt($this.val());

		if (isNaN(qty) || qty <= qtyMin) {
			$this.val(qtyMin);
			$minusBtn.attr("disabled", true);
		} else {
			$minusBtn.attr("disabled", false);
			
			if(qty >= qtyMax){
				$this.val(qtyMax);
				$addBtn.attr('disabled', true);
			} else {
				$this.val(qty);
				$addBtn.attr('disabled', false);
			}
		}
	});

	$countBtn.click(function () {
		var operator = this.dataset.action;
		var $this = $(this);
		var $input = $this.siblings(".product-qty");
		var qty = parseInt($input.val());

		if (operator == "add") {
			qty += 1;
			if (qty >= qtyMin + 1) {
				$this.siblings(".qty-count--minus").attr("disabled", false);
			}

			if (qty >= qtyMax) {
				$this.attr("disabled", true);
			}
		} else {
			qty = qty <= qtyMin ? qtyMin : (qty -= 1);
			
			if (qty == qtyMin) {
				$this.attr("disabled", true);
			}

			if (qty < qtyMax) {
				$this.siblings(".qty-count--add").attr("disabled", false);
			}
		}

		$input.val(qty);
	});
})();

   
   